function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "left-8_svg__a",
  x1: "42.822%",
  x2: "70.992%",
  y1: "23.52%",
  y2: "84.414%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#left-8_svg__a)",
  fillRule: "evenodd",
  d: "M256.96 216.286c-42.225 0-75.18 35.084-75.18 75.18 0 40.096 33.985 74.177 75.18 74.177 41.195 0 76.21-34.081 76.21-74.177 0-41.099-33.985-75.18-76.21-75.18m0 273.655c-60.762 0-110.196 48.125-110.196 107.257 0 59.141 49.434 107.256 110.196 107.256 60.763 0 110.197-48.115 110.197-107.256 0-59.132-49.434-107.257-110.197-107.257m0 333.809C129.256 823.75 17 723.51 17 597.198c0-77.185 37.075-139.334 107.107-175.42-40.165-38.092-63.852-76.183-63.852-132.317C60.255 181.2 145.734 97 256.96 97c111.226 0 197.736 84.202 197.736 192.46 0 56.135-24.717 94.226-64.882 132.318 70.031 36.086 107.106 98.235 107.106 175.42C495.89 723.51 384.664 823.75 256.96 823.75",
  transform: "translate(-17 -97)"
});

var SvgLeft8 = function SvgLeft8(props) {
  return React.createElement("svg", _extends({
    width: 480,
    height: 727
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/left-8.f02af1e8.svg";
export { SvgLeft8 as ReactComponent };